import { LoadingOutlined } from "@ant-design/icons";
import { Progress, Result } from "antd";
import React, { ReactNode } from "react";
import { DataImportResultsProps } from "./data-import-results";

export const DataImportResultSection: React.FC<DataImportResultsProps> = ({
  importingState,
  importResults,
  progress,
}) => {
  const importErrorCount = (importResults?.importErrors && importResults.importErrors.length) || 0;
  const hasImportErrors = importErrorCount || 0 > 0;
  const importingTitle = () => {
    if (importResults) {
      return hasImportErrors
        ? `Completed with error${importErrorCount > 1 ? "s" : ""}`
        : `Successfully imported ${importResults.entityType}`;
    }
    switch (importingState) {
      case "importing":
        return "Reading Data from file . . .";
      case "import-success":
        return "Importing Data . . . ";
    }
  };

  const icon = (): ReactNode => {
    if (importingState === "importing") {
      return <LoadingOutlined />;
    }

    if (importingState === "import-success") {
      return progress.hasError ? (
        <Progress type="circle" percent={progress.percentage} status="exception" />
      ) : (
        <Progress type="circle" percent={progress.percentage} />
      );
    }
  };

  return (
    <Result
      title={importingTitle()}
      icon={icon()}
      subTitle={
        importResults && (
          <h1>
            Created {importResults.created} Updated {importResults.updated} Deleted{" "}
            {importResults.deleted}
          </h1>
        )
      }
    />
  );
};
